module.exports = __webpack_public_path__ + "static/media/ppe.0f9336f2.svg";